import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Bookmark = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="vuesax/linear/archive-add">
        <g id="archive-add">
          <path
            id="Vector"
            d="M11.2148 1.3335H4.78818C3.36818 1.3335 2.21484 2.4935 2.21484 3.90683V13.3002C2.21484 14.5002 3.07484 15.0068 4.12818 14.4268L7.38151 12.6202C7.72818 12.4268 8.28818 12.4268 8.62818 12.6202L11.8815 14.4268C12.9348 15.0135 13.7948 14.5068 13.7948 13.3002V3.90683C13.7882 2.4935 12.6348 1.3335 11.2148 1.3335Z"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};

Bookmark.displayName = 'Bookmark';
